export const peqAlmocosInitialState = {
  peqAlmocos: [],

  enviarPeqAlmocos: [],
};
